import { get, set, del } from 'idb-keyval';
export function validateSubmission(currentPage, responses) {
    const validations = {};
    const invalids = [];
    getCurrentQuestionList(currentPage, responses).forEach((question) => {
        if (!question.requireResponse) {
            return;
        }
        const id = `${currentPage.pageName}${DIV}${question.id}`;
        // matrix requires non-standard validation
        if (question.type === 'matrix-question') {
            const matrixRows = getDisplayValue(responses, question, 'rows');
            const respondedToAllRows = matrixRows.every((row) => responses[`${id}-${row}`]);
            if (!respondedToAllRows) {
                validations[id] = 'Must respond to all rows';
                invalids.push(validations[id]);
                return;
            }
        }
        else {
            // everything else can just use simple validation
            const response = responses[id];
            if (!response) {
                validations[id] = 'Requires Response';
                invalids.push(validations[id]);
                return;
            }
        }
        // custom validation
        const customValidation = question.customValidation;
        if (customValidation && customValidation(responses, id)) {
            validations[id] = customValidation(responses, id);
            invalids.push(validations[id]);
            return;
        }
    });
    return { allValid: !invalids.length, validations };
}
export function clearCache(name) {
    return Promise.all([
        del(`${name}-events`),
        del(`${name}-responses`),
        del(`${name}-pageStack`),
        del(`${name}-currentPageName`)
    ]);
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.clearCurrentSurveyData = () => {
    const hash = location.hash.split('#/');
    console.log(hash);
    if (hash && hash.length === 2) {
        clearCache(hash[1]);
        document.location.reload();
    }
};
export const getCurrentQuestionList = (currentPage, responses) => currentPage.questions.filter((question) => !question.condition || question.condition(responses));
export async function getUserId() {
    let userId = await get('ss-user-id');
    if (!userId) {
        // https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
        userId = Date.now().toString(36) + Math.random().toString(36).substring(2);
    }
    set('ss-user-id', userId);
    return userId;
}
export const groupBy = (arr, key) => arr.reduce((acc, row) => {
    acc[row[key]] = row;
    return acc;
}, {});
export const postResult = async (responses, userId, survey, events, pageStack) => {
    const data = { responses, survey: survey.urlName, userId, events, pageStack };
    return (fetch('/.netlify/functions/collect', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(data)
    })
        .then((x) => x.json())
        // .then((x) => console.log(x))
        .catch((e) => {
        console.log(e);
    }));
};
export function getDisplayValue(currentResponses, question, key) {
    return typeof question[key] === 'function' ? question[key](currentResponses) : question[key];
}
// https://stackoverflow.com/questions/46155/whats-the-best-way-to-validate-an-email-address-in-javascript
const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
export const emailValidation = (responses, key) => {
    const response = responses[key];
    if (!response.length) {
        return null;
    }
    return !validateEmail(response) ? 'Response must be a valid email' : null;
};
export const DIV = '##';
export const fillInBlankUniqueValidation = (responses, key) => {
    const response = responses[key];
    if (!Array.isArray(response)) {
        return 'Requires response';
    }
    const groups = response.reduce((acc, row) => {
        const name = row.toLowerCase();
        acc[name] = (acc[name] || 0) + 1;
        return acc;
    }, {});
    const hasDuplicates = !Object.values(groups).every((x) => x === 1);
    return hasDuplicates ? 'Entries must be unique' : null;
};
export const elementMutuallyDisallowsOtherOptions = (element) => (responses, key) => {
    const response = responses[key];
    if (!Array.isArray(response)) {
        return null;
    }
    return response.find((x) => x === element) && response.length !== 1
        ? `"${element}" is mutually exclusive with other options`
        : null;
};
export function onSurveyLoad(survey) {
    return (fetch('/.netlify/functions/load', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({ survey, hostname: location.host })
    })
        .then((x) => x.json())
        // .then((x) => console.log(x))
        .catch((e) => {
        console.log(e);
    }));
}
export const chainValidations = (validations) => (responses, key) => {
    for (let idx = 0; idx < validations.length; idx++) {
        const result = validations[idx](responses, key);
        if (result) {
            return result;
        }
    }
    return null;
};
